import { Component, computed, input } from '@angular/core';
import { ILpCanvasElementContext } from '@features/lp/lp-canvas/lp-canvas.types';
import { convertLpColorToCSSColor } from '@shared/lp.utils';
import { LpSolidColorCanvasComponent } from '@typings/lp/generated';

@Component({
  selector: 'lp-solid-color-canvas-component',
  imports: [],
  templateUrl: './lp-solid-color-canvas-component.component.html',
  styleUrl: './lp-solid-color-canvas-component.component.css',
})
export class LpSolidColorCanvasComponentComponent {
  comp = input.required<LpSolidColorCanvasComponent>();
  context = input.required<ILpCanvasElementContext>();

  color = computed(() => convertLpColorToCSSColor(this.comp().color));
}
